import { ActivityFeedItem } from '../services/pusher.service';
import General from '../utils/GeneralUtils';
import { FeedEventTag } from './FeedEventTag';
import { getFeedItemDescription } from './feedItemDescription';
import './FeedItem.scss';

interface FeedItemProps {
  item: ActivityFeedItem;
  isNew?: boolean;
}

export function FeedItem({ item, isNew }: FeedItemProps) {
  const timeAgo = General.daysAgo(item.deliveredAt);
  const descriptionContent = getFeedItemDescription(item);

  return (
    <div className={isNew ? 'feed-item feed-item--new' : 'feed-item'}>
      <div className="feed-item__header">
        <span className="feed-item__time">{timeAgo}</span>
        <FeedEventTag eventType={item.eventType} />
      </div>
      <div className="feed-item__description">
        {descriptionContent}
      </div>
    </div>
  );
}
